import { render, staticRenderFns } from "./combat_knockout.vue?vue&type=template&id=2e0db7e4&scoped=true"
import script from "./combat_knockout.vue?vue&type=script&lang=js"
export * from "./combat_knockout.vue?vue&type=script&lang=js"
import style0 from "./combat_knockout.vue?vue&type=style&index=0&id=2e0db7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0db7e4",
  null
  
)

export default component.exports